import { IPageTabNavLink } from "../interfaces-and-types";

export const bankaccountpayoutLink: IPageTabNavLink[] = [
    {
        name: 'Bank accounts/currencies and payout settings',
        route: '',
    },
]